export function calculateSeaLevelPressure(altitude, pressure) {
  const seaLevelPressure = pressure / (1 - altitude / 44330) ** 5.255; // Calculate sea level pressure in hPa
  return parseInt(seaLevelPressure);
}
